import { useEffect, useState } from "react";
import { CreditCard, FileText, LogIn, User } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { LI, UL } from "../../../AbstractElements";
import { avatarOrNull, fetchProfile } from "../../../helpers/profileApi";

/**
 * Кнопка профиля в правом углу шапки.
 *
 * По макету (fw-lk-cabinet.vercel.app) рядом с иконкой видно, кто вошёл и
 * с какой ролью: человек с несколькими открытыми ролями должен понимать,
 * от чьего имени смотрит кабинет.
 *
 * Из выпадающего списка убраны пункты шаблона — Account, Inbox и Settings
 * вели на демо-страницы купленной темы: чужой профиль, почтовик и форму
 * редактирования пользователя, которых в проекте нет.
 */
const Users = () => {
  const [toggle, setToogle] = useState(true);
  const history = useNavigate();

  // Роль придёт с бэкенда вместе с профилем; до тех пор все, кто вошёл, —
  // Гость: это состояние по умолчанию, а не заглушка.
  const role = localStorage.getItem("role") || "Гость";
  // «Emay Walter» — демо-имя шаблона. Оно могло остаться в localStorage от
  // прежних входов, поэтому отсекаем его и здесь, а не только при входе.
  const stored = localStorage.getItem("Name") || "";

  // Имя и фото берём с платформы: в шапке должно быть видно живого человека,
  // а не безличную иконку. Пока профиль не пришёл — то, что сохранено локально.
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchProfile()
      .then((data) => {
        if (alive) setProfile(data && data.user ? data.user : null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const fromApi = profile
    ? [profile.name_first, profile.name_last].filter(Boolean).join(" ").trim()
    : "";
  const name = fromApi || (stored === "Emay Walter" ? "" : stored);
  // Не `profile.photo`, а через avatarOrNull: платформа вместо пустого поля
  // отдаёт свою заглушку iam.png, и с ней инициалы ниже не показывались бы
  // никогда — у всех, кто не загружал фото, висел чужой серый силуэт.
  const photo = avatarOrNull(profile && profile.photo);

  /* Инициалы — запасной вариант, когда фото не загружено. Буква узнаётся
     быстрее серой иконки: человек видит, что кабинет знает, кто он.
     Почта в запасе после имени: анкету заполняют не все, а почта есть у
     каждого, кто вошёл, — и первая буква адреса всё равно его собственная. */
  const initialsFrom = name || (profile && profile.email) || "";
  const initials = initialsFrom
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  const Logout = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("Name");
    localStorage.removeItem("token");
    localStorage.setItem("login", false);
    history(`${process.env.PUBLIC_URL}/login`);
  };

  const Active = () => setToogle(!toggle);

  return (
    <>
    {/* Подпись отдельным пунктом, а не внутри .profile-nav: тема считает,
        что там лежит только иконка, и рисует по ней подсветку при наведении
        и положение выпадающего списка. Вложенная обёртка ломала и то, и другое. */}
    <LI attrLI={{ className: `align-items-center header-user-title` }}>
      <div className="lh-sm text-end">
        {name ? <div className="f-w-600 f-12 header-user-name">{name}</div> : null}
        {/* Роль под именем показываем, только если она содержательная:
            подпись «Гость» под собственным именем выглядит ошибкой. */}
        {!name || role !== "Гость" ? (
          <div className="f-11 txt-primary">{role}</div>
        ) : null}
      </div>
    </LI>

    <LI attrLI={{ className: `profile-nav onhover-dropdown` }}>
      <div className="account-user fw-avatar" onClick={Active}>
        {photo ? (
          <img src={photo} alt={name || "Профиль"} />
        ) : initials ? (
          <span className="fw-avatar-initials">{initials}</span>
        ) : (
          <User />
        )}
      </div>

      {/* Личные разделы живут здесь, а не в боковом меню: Максим 22.08.2026.
          Слева остаётся работа над мирами, под аватаркой — всё про себя.
          Так человеку не приходится решать, к какой из двух колонок
          относится «Кошелёк». */}
      <UL attrUL={{ className: "profile-dropdown onhover-show-div" }}>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/profile`}>
            <User />
            <span>Профиль</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/wallet`}>
            <CreditCard />
            <span>Кошелёк</span>
          </Link>
        </LI>
        <LI>
          <Link to={`${process.env.PUBLIC_URL}/documents`}>
            <FileText />
            <span>Документы</span>
          </Link>
        </LI>
        <LI attrLI={{ onClick: Logout }}>
          <Link to={`${process.env.PUBLIC_URL}/login`}>
            <LogIn />
            <span>Выйти</span>
          </Link>
        </LI>
      </UL>
    </LI>
    </>
  );
};

export default Users;
